<template>
  <a-modal
    title="编辑医院信息/备案"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['orgId']" /></a-form-item>
        <a-form-item
          label="机构编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构编码" v-decorator="['orgCode', {rules: [{required: true, message: '请输入机构编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="机构名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构名称" v-decorator="['orgName', {rules: [{required: true, message: '请输入机构名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="机构描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构描述" v-decorator="['orgDesc']" />
        </a-form-item>
        <a-form-item
          label="机构类型，来源于字典表value_id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构类型，来源于字典表value_id" v-decorator="['orgType']" />
        </a-form-item>
        <a-form-item
          label="机构等级(等) 来源于字典表value_id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构等级(等) 来源于字典表value_id" v-decorator="['orgGrade']" />
        </a-form-item>
        <a-form-item
          label="所在省(来源ba_province表pid字段)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入所在省(来源ba_province表pid字段)" v-decorator="['provId', {rules: [{required: true, message: '请输入所在省(来源ba_province表pid字段)！'}]}]" />
        </a-form-item>
        <a-form-item
          label="所在市（来源ba_city表cid字段）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入所在市（来源ba_city表cid字段）" v-decorator="['cityId', {rules: [{required: true, message: '请输入所在市（来源ba_city表cid字段）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="所在区县（来源ba_district表distid字段）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入所在区县（来源ba_district表distid字段）" v-decorator="['distId', {rules: [{required: true, message: '请输入所在区县（来源ba_district表distid字段）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="机构logo图片"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构logo图片" v-decorator="['orgLogoUrl']" />
        </a-form-item>
        <a-form-item
          label="大图"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入大图" v-decorator="['orgImageUrl']" />
        </a-form-item>
        <a-form-item
          label="小图"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入小图" v-decorator="['orgImagetbUrl']" />
        </a-form-item>
        <a-form-item
          label="详细地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入详细地址" v-decorator="['address']" />
        </a-form-item>
        <a-form-item
          label="联系邮箱"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入联系邮箱" v-decorator="['email']" />
        </a-form-item>
        <a-form-item
          label="电话号码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入电话号码" v-decorator="['phone']" />
        </a-form-item>
        <a-form-item
          label="邮编"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入邮编" v-decorator="['postcode']" />
        </a-form-item>
        <a-form-item
          label="联系人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入联系人" v-decorator="['linkman']" />
        </a-form-item>
        <a-form-item
          label="创建时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择创建时间戳！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="简介"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入简介" v-decorator="['orgIntroduction']" />
        </a-form-item>
        <a-form-item
          label="医保授权码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医保授权码" v-decorator="['medsurNo', {rules: [{required: true, message: '请输入医保授权码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="医疗机构编码(18 位“统一社会信用代码”)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入医疗机构编码(18 位“统一社会信用代码”)" v-decorator="['medorgCode', {rules: [{required: true, message: '请输入医疗机构编码(18 位“统一社会信用代码”)！'}]}]" />
        </a-form-item>
        <a-form-item
          label="机构正式成立日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入机构正式成立日期" v-decorator="['openDatetime', {rules: [{required: true, message: '请输入机构正式成立日期！'}]}]" />
        </a-form-item>
        <a-form-item
          label="互联网执业许可发证日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择互联网执业许可发证日期" v-decorator="['authorizeDate',{rules: [{ required: true, message: '请选择互联网执业许可发证日期！' }]}]" @change="onChangeauthorizeDate"/>
        </a-form-item>
        <a-form-item
          label="互联网执业许可生效日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择互联网执业许可生效日期" v-decorator="['effectiveDate',{rules: [{ required: true, message: '请选择互联网执业许可生效日期！' }]}]" @change="onChangeeffectiveDate"/>
        </a-form-item>
        <a-form-item
          label="互联网执业许可到期日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择互联网执业许可到期日期" v-decorator="['expireDate',{rules: [{ required: true, message: '请选择互联网执业许可到期日期！' }]}]" @change="onChangeexpireDate"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baOrganizationEdit } from '@/api/modular/interhospital/baorganization/baOrganizationManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        authorizeDateDateString: '',
        effectiveDateDateString: '',
        expireDateDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              orgId: record.orgId,
              orgCode: record.orgCode,
              orgName: record.orgName,
              orgDesc: record.orgDesc,
              orgType: record.orgType,
              orgGrade: record.orgGrade,
              provId: record.provId,
              cityId: record.cityId,
              distId: record.distId,
              orgLogoUrl: record.orgLogoUrl,
              orgImageUrl: record.orgImageUrl,
              orgImagetbUrl: record.orgImagetbUrl,
              address: record.address,
              email: record.email,
              phone: record.phone,
              postcode: record.postcode,
              linkman: record.linkman,
              orgIntroduction: record.orgIntroduction,
              medsurNo: record.medsurNo,
              medorgCode: record.medorgCode,
              openDatetime: record.openDatetime
            }
          )
        }, 100)
        // 时间单独处理
        if (record.ctstamp != null) {
            this.form.getFieldDecorator('ctstamp', { initialValue: moment(record.ctstamp, 'YYYY-MM-DD') })
        }
        this.ctstampDateString = moment(record.ctstamp).format('YYYY-MM-DD')
        // 时间单独处理
        if (record.authorizeDate != null) {
            this.form.getFieldDecorator('authorizeDate', { initialValue: moment(record.authorizeDate, 'YYYY-MM-DD') })
        }
        this.authorizeDateDateString = moment(record.authorizeDate).format('YYYY-MM-DD')
        // 时间单独处理
        if (record.effectiveDate != null) {
            this.form.getFieldDecorator('effectiveDate', { initialValue: moment(record.effectiveDate, 'YYYY-MM-DD') })
        }
        this.effectiveDateDateString = moment(record.effectiveDate).format('YYYY-MM-DD')
        // 时间单独处理
        if (record.expireDate != null) {
            this.form.getFieldDecorator('expireDate', { initialValue: moment(record.expireDate, 'YYYY-MM-DD') })
        }
        this.expireDateDateString = moment(record.expireDate).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.ctstamp = this.ctstampDateString
            values.authorizeDate = this.authorizeDateDateString
            values.effectiveDate = this.effectiveDateDateString
            values.expireDate = this.expireDateDateString
            baOrganizationEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangeauthorizeDate(date, dateString) {
        this.authorizeDateDateString = dateString
      },
      onChangeeffectiveDate(date, dateString) {
        this.effectiveDateDateString = dateString
      },
      onChangeexpireDate(date, dateString) {
        this.expireDateDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
